module.exports = __webpack_public_path__ + "img/alert_cn.1784904b.svg";